/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import useInvoiceService, { INVOICE_CLASSIFICATION } from 'domain/finance/invoice/useInvoiceService';
import { useInvoiceUrl, useInvoiceId } from 'domain/finance/invoice/shared/useInvoiceRouting';
import CreateInvoiceBreadcrumbs from 'domain/finance/invoice/createupdate/Create/Breadcrumbs';
import InvoiceForm from 'domain/finance/invoice/createupdate/InvoiceForm';

const CreateInvoicePage = () => {
  const { create, getValidationSchema, getById } = useInvoiceService();
  const { getSingleEntityUrl } = useInvoiceUrl();
  let getDataFunc;
  const id = useInvoiceId();

  if (id) {
    getDataFunc = async () => {
      const data = await getById(id);

      return {
        invoiceNumber: data.invoiceNumber,
        invoiceDate: data.invoiceDate,
        office: data.office,
        name: data.name,
        isFutureExpense: data.isFutureExpense,
        account: data.account,
        budgetCategory: data.budgetCategory,
        references: data.references,
        description: data.description,
        requisites: data.requisites,
        isPurchaseClassifiedAsAsset: data.isPurchaseClassifiedAsAsset
          ? INVOICE_CLASSIFICATION.ASSET
          : INVOICE_CLASSIFICATION.OTHER,
      };
    };
  }

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={getDataFunc}
      afterSubmit={{
        redirect: data => getSingleEntityUrl(data.id),
        message: 'You are awesome! The Invoice has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        subTotal: {
          currency: 'USD',
        },
      }}
    >
      <CreatePageLayout breadcrumbs={<CreateInvoiceBreadcrumbs />} title="Create: Invoice">
        <InvoiceForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateInvoicePage;
